<template>
  <div class="header mb10">
    <div class="project-detail">
      <span class="mr5"
        ><span class="bolder">项目创建时间：</span>{{ dateFormat(project.createdAt, 'yyyy-mm-dd') }}</span
      >
      <span class="mr5"
        ><span class="bolder">进展天数：</span>{{ passed(project.startTime || project.createdAt) }}天</span
      >
      <span v-if="step === '职位推荐'" class="mr5"
        ><span class="bolder">已推荐：</span>{{ (project.recommends && project.recommends.length) || 0 }}人</span
      >
    </div>
    <div class="project-member">
      <span class="mr10 keep-all"
        ><span class="bolder">客户开发：</span>{{ (project['客户开发'] || []).join('、') }}</span
      >
      <span class="mr10 keep-all"
        ><span class="bolder">项目对接：</span>{{ (project['项目对接'] || []).join('、') }}</span
      >
      <span class="mr10 keep-all"
        ><span class="bolder">项目经理：</span>{{ (project['项目经理'] || []).join('、') }}</span
      >
      <span class="mr10 keep-all"
        ><span class="bolder">项目成员：</span>{{ (project['项目成员'] || []).join('、') }}</span
      >
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
  },
  data() {
    return {}
  },
  methods: {
    dateFormat(time, format) {
      return dateFormat(time, format)
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
  },
}
</script>
<style scoped>
.header {
  margin-top: -30px;
  color: #a6a4a4;
}
.bolder {
  font-weight: 700;
}
.project-detail .mr5 {
  margin-right: 60px;
}
</style>
